import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { RemovingEventArgs, SelectedEventArgs, UploaderComponent } from '@syncfusion/ej2-angular-inputs';
import { DialogComponent, TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { detach, EmitType } from '@syncfusion/ej2-base';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { fadeInOut } from '../../shared/helpers/animations';
import { IFileIngestionHistory, IPermission, IServerSettings, IServiceError } from '../../shared/models/index';
import { AuthenticationService } from '../../shared/services/authentication.service';
import { FileUploadService, SettingsService, StorageManagerService } from '../../shared/services/index';


@Component({
	selector: 'app-fileupload',
	templateUrl: './fileupload.component.html',
	styleUrls: ['./fileupload.component.css'],
	animations: [fadeInOut],
	encapsulation: ViewEncapsulation.None
})
export class FileuploadComponent implements OnInit, AfterViewInit, OnDestroy {
	gridData: string;
	recordCount = 0;
	error: string;
	subscription: Subscription;
	public dropElement: HTMLElement;
	private settings: IServerSettings;
	private apiGatewayUrl: string;
    userGuid: string;


	@ViewChild('modalDialog', { static: true })
  modalDialog: DialogComponent;
  @ViewChild('tooltipObj') tooltipObj: TooltipComponent;

	target = '#modalTarget';
	modalHeader: string;
	modalContent: string;
	modalWidth: string;
	animationSettings: Object = { effect: 'Zoom' };
	hide: any;
	position: object = { X: 'center', Y: 'center' };
	isModal: Boolean = true;
	public visible: Boolean = true;
	public hidden: Boolean = false;

	@ViewChild('grid')
	public grid: GridComponent;

	@ViewChild('defaultupload')
	public uploadObj: UploaderComponent;

	public path: Object;
	public allowExtensions = '.xml, .xlsx';
	public fileMaxSize: number;
	public fileMinSize: number;
	fileNameLength: number;
  restrictedWords: string;
  permissionsConst: any;

	private customerId: string;
	private customerGuid: string;

	invalidChars = ['"', '<', '>', '|', ';', ':', '*', '?', '\\', '/'];

	resolverData: any[] = [];
	appDefaults: any;


	dlgButtonClick: EmitType<object> = () => {
		this.modalDialog.hide();
	}

	// tslint:disable-next-line:member-ordering
	public buttons: Object[] = [{ click: this.dlgButtonClick.bind(this), buttonModel: { content: 'OK', isPrimary: true } }];
  // tslint:disable-next-line:member-ordering
  permissionsPerClient: string[];
  // tslint:disable-next-line:member-ordering
  permissionsPerClientSet$: BehaviorSubject<string[]> | null;
  // tslint:disable-next-line:member-ordering
  permissionSet: IPermission[] = [];

	constructor (private fileUploadService: FileUploadService, private activatedRoute: ActivatedRoute, private storageManagerService: StorageManagerService,
    private settingsService: SettingsService, private authService: AuthenticationService, private appGlobals: AppGlobals) {
	}

	// tslint:disable-next-line:member-ordering
	fileHistory: IFileIngestionHistory[];
	public changeHandler: EmitType<Object> = () => {
		this.uploadObj.autoUpload = true;
		this.uploadObj.clearAll();
	}

  ngOnInit() {
    this.permissionsConst = this.appGlobals.permissions;
		this.settings = this.settingsService.getSettings();
		this.apiGatewayUrl = this.settings.ApiGatewayUrl;
		this.fileNameLength = +this.settings.FileNameLength;
		this.fileMinSize = +this.settings.FileMinSize;
		this.fileMaxSize = +this.settings.FileMaxSize;
		this.path = {
			saveUrl: this.apiGatewayUrl + '/fms/v1/FileManagement/UploadFileUI'
    };

		this.storageManagerService.write('activeTab', 'device');

		this.userGuid = this.storageManagerService.read('userGuid');

		// customerId is set and used in the Resolver but for the RefreshUploadHistory it needs to be present in the component
		const currentCustomerStr: string = this.storageManagerService.read('currentCustomer');
		const currentCustomer = typeof currentCustomerStr === 'object' ? currentCustomerStr : JSON.parse(currentCustomerStr);
		if (currentCustomer) {
			this.customerId = currentCustomer.customerId;
            this.customerGuid = currentCustomer.customerGuid;
        }

		// Get data pre-populated in the Resolver or a seriveError object
		this.resolverData = this.activatedRoute.snapshot.data['fileHistory'];

    if (this.resolverData && this.resolverData.length > 0) {

      this.appDefaults = this.resolverData[0].fileUploadGrid;
      this.fileHistory = this.resolverData[1]; // mock  this.resolverData[2];

      // Get data pre-populated in the Resolver
      if (this.fileHistory instanceof IServiceError) {
        this.error = this.fileHistory.friendlyMessage;
      } else {
        if (Array.isArray(this.fileHistory)) {
          this.recordCount = this.fileHistory.length;
          this.gridData = JSON.stringify(this.fileHistory);
        } else {
          this.error = this.fileHistory;
        }
      }
    }
  // set focus on the invisible div so the firest tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  tooltipValue(args) {
    // here you can get the row data of the target cell
    if (args.target.scrollWidth <= args.target.clientWidth) {
      args.cancel = true;
    } else {
      const rowInfo = this.grid.getRowInfo(args.target);
      const rowData = rowInfo.rowData;
      this.tooltipObj.content = rowData[(rowInfo.column as any).field];
      this.tooltipObj.width = `${ args.target.scrollWidth }px`;
    }
  }


  getPerClientPermission(permission): boolean {

    let retVal = false;
    this.permissionSet = this.storageManagerService.read('accessPermissions');

    if (permission && (this.permissionSet && this.permissionSet.length)) {

      retVal = this.permissionSet.findIndex(p => p.permissionName.toLowerCase() === permission.toLowerCase()) >= 0;
    }

    return retVal;
  }

  ngAfterViewInit() {

		if (this.uploadObj) {
			this.uploadObj.dropArea = document.getElementById('dropTarget');

			document.getElementById('droppingArea').onclick = (e: any) => {
				const target: HTMLElement = <HTMLElement>e.target;
				if (target.classList.contains('e-file-delete-btn')) {
					for (let i = 0; i < this.uploadObj.getFilesData().length; i++) {
						if (target.parentElement.getAttribute('data-file-name') === this.uploadObj.getFilesData()[i].name) {
							this.uploadObj.remove(this.uploadObj.getFilesData()[i]);
						}
					}
				} else if (target.classList.contains('e-file-remove-btn')) {
					detach(target.parentElement);
				}
			};
		}

    this.modalDialog.hide();
	}

  browseClick(e) {

    const type = e.type;

    if (type === 'click' || (type === 'keydown' && (e.which === 13 || e.keyCode === 13))) {

      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
      e.preventDefault();
      e.stopPropagation();
    } 
	}

	public onSelect: EmitType<Object> = (args: any) => {
		const allowedTypes: string[] = ['xml', 'xlsx'];
		const modifiedFiles: object[] = [];
		for (const file of args.filesData) {
			if (allowedTypes.indexOf(file.type.toLowerCase()) > -1) {
				modifiedFiles.push(file);
			}
		}
		if (modifiedFiles.length > 0) {
			args.isModified = true;
			args.modifiedFilesData = modifiedFiles;
		} else { args.cancel = true; }
	}

	public onFileUpload: EmitType<SelectedEventArgs> = (args: any) => {

		if (args) {

			const authData = this.authService.getAuthData();

			args.currentRequest.setRequestHeader('authorization', this.authService.getBearerToken());
            args.currentRequest.setRequestHeader('customerGuid', this.customerGuid);
            args.currentRequest.setRequestHeader('applicationName', authData.applicationName ? authData.applicationName.toString() : 'SingleSource');

			args.customFormData = [
				{ 'userGuid': this.storageManagerService.read('userGuid') },
				{ 'customerId': this.customerId }
			];

			const fileData = args.fileData;

			const sizeInBytes: number = fileData.size;
			const fileType: string = fileData.type;
			let fileName: string = fileData.name;

			// Check file size
			if (fileData.size > this.fileMaxSize || fileData.size < this.fileMinSize) {
				this.setupAlertBox('File upload validation', 'File size should not be smaller than ' + this.fileMinSize + ' and larger than ' + this.fileMaxSize + 'bytes', '450px');

				this.modalDialog.show();

				this.logError('File size should not be smaller than ' + this.fileMinSize + ' and larger than ' + this.fileMaxSize + 'bytes');
				args.cancel = true;
			}

			// Check file name against special characters
			fileName = fileName.substr(0, fileName.indexOf('.' + fileType));

			this.invalidChars.forEach(char => {
				if (fileName.indexOf(char) > -1) {

					this.setupAlertBox('File upload validation', 'Special Characters' + this.invalidChars.toString() + ' are not allowed in the file name', '450px');

					this.modalDialog.show();

					this.logError('Special characters used in the file name');
					args.cancel = true;
					return;
				}
			});

			// Check file name agains restricted words
			const matches = /^(ON|PRN|AUX|NUL|CON|COM\d|LPT\d)$/.test(fileName.toUpperCase());

			if (matches) {

				this.setupAlertBox('File upload validation', 'File name contains restricted words.', '450px');

				this.modalDialog.show();
				this.logError('File name contains restricted words.');
				args.cancel = true;
			}

			// Check file's type
			if (fileType !== 'xml' && fileType !== 'xlsx') {

				this.setupAlertBox('File upload validation', 'File type ' + fileType + ' is not supported', '450px');

				this.modalDialog.show();

				this.logError('File type ' + fileType + ' is not supported');
				args.cancel = true;
			}

			// Check file name length
			if (fileName.length > this.fileNameLength) {
				this.setupAlertBox('File upload validation', 'File name should not exceed ' + this.fileNameLength + ' characters', '450px');

				this.modalDialog.show();

				this.logError('File name should not exceed ' + this.fileNameLength + ' characters');
				args.cancel = true;
			}

		}

	}

	setupAlertBox(header: string, contents: string, width: string) {
		this.modalHeader = header;
		this.modalContent = contents;
		this.modalWidth = width;
	}

	public onUploadFailure(args: any): void {
		console.log('File failed to upload');

	}

	public onFileUploaded: EmitType<Object> = (args: any) => {
		this.RefreshUploadHistory();

		setTimeout(() => {
			this.uploadObj.clearAll();
		}, 3000);
	}

	public onFileRemove(args: RemovingEventArgs): void {
		args.postRawFile = false;
	}

	public addHeaders(args: any) {
		args.currentRequest.setRequestHeader('Access-Control-Allow-Origin', '*');
	}

	private RefreshUploadHistory() {

		this.subscription = this.fileUploadService.fetchUploadedFileHistory(this.customerId).subscribe(
			(data: IFileIngestionHistory[]) => {
				if (data) {
					this.recordCount = data.length;
					this.gridData = JSON.stringify(data);
				}
			});
	}

	private logError(message: string) {
		let errorResp = '';

		this.subscription = this.authService.get('api/security/FileValidation?message=' + message).subscribe(a => errorResp = a);
	}

    receiveMessage($event) {
        this.recordCount = $event;
    }

	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}

/*
  DO WE have the ability to control the prompt's File Type display list, so that it displays the file types in the (OPEN) dialog box?
  No. It is written to always display CUSTOM for FILE formats... Here's why:
  https://stackoverflow.com/questions/21534729/show-custom-text-for-applied-file-type-filters-on-file-dialog-to-upload-particul

*/
